// src/pages/ClaimForms/AddEditForm.jsx

import React, { useEffect } from 'react';
import { Form, Input, Button, Select } from 'antd';
import { toast } from 'react-toastify';
import apiRequest from '../../hooks/ApiRequest';

const AddEditForm = ({ form, claimFormId, onSuccess, products = [] }) => {
    const { getFieldDecorator, resetFields, setFieldsValue } = form;
    const { Option } = Select;

    const insurerId = localStorage.getItem('insurerId')
        ? parseInt(localStorage.getItem('insurerId'), 10)
        : null;
    const loggedInInsurerName = localStorage.getItem('username') || 'Insurer';

    useEffect(() => {
        if (claimFormId && products.length > 0) {
            fetchFormById(claimFormId);
        } else if (!claimFormId) {
            form.resetFields();
            form.setFieldsValue({ insurerId });
        }
    }, [claimFormId, products]);



    const fetchFormById = async (id) => {
        try {
            const res = await apiRequest(`${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/${id}`, 'GET');
            console.log('API response:', res);

            const formData = res?.data || res;
            if (formData && formData.name) {
                form.setFieldsValue({ name: formData.name, productId: formData.productId, insurerId: formData.insurerId, });
            } else {
                toast.error('Failed to load form - No name in response');
            }

        } catch (err) {
            console.error('Fetch error:', err);
            toast.error('Error fetching form');
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (err) return;


            // debugger;x
            const payload = {
                id: claimFormId || 0,
                name: values.name,
                productId: values.productId,
                insurerId,
            };

            const url = claimFormId
                ? `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/update`
                : `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/add`;
            // debugger;

            try {
                const res = await apiRequest(url, 'POST', payload);
                if (res?.success && res?.statusCode === 200 && res?.data?.id) {
                    toast.success(claimFormId ? 'Form updated successfully' : 'Form added successfully');
                    onSuccess && onSuccess();
                } else {
                    toast.error(res.message || 'Operation failed');
                }
            } catch (err) {
                toast.error('Request failed');
            }

        });
    };

    return (
        <Form layout="vertical" onSubmit={handleSubmit}>
            <Form.Item label="Form Name">
                {getFieldDecorator('name', {
                    rules: [{ required: true, message: 'Please enter form name' }],
                })(<Input placeholder="Enter form name" />)}
            </Form.Item>

            <Form.Item label="Product">
                {getFieldDecorator('productId', {
                    rules: [{ required: true, message: 'Please select a type' }],
                })(
                    <Select placeholder="Select a product">
                        {products.map(product => (
                            <Option key={product.productid} value={product.productid}>
                                {product.productname}
                            </Option>
                        ))}
                    </Select>
                )}
            </Form.Item>

            <Form.Item label="Insurer">
                {getFieldDecorator('insurerId', {
                    initialValue: insurerId,
                    rules: [{ required: true, message: 'Please select an insurer' }],
                })(
                    <Select disabled>
                        <Option value={insurerId}>{loggedInInsurerName}</Option>
                    </Select>
                )}
            </Form.Item>


            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Save
                </Button>
            </Form.Item>
        </Form>
    );
};

export default Form.create({ name: 'add_edit_claim_form' })(AddEditForm);